import { Component, Host, h, Prop, Element } from '@stencil/core';

/**
 * @slot  - Slot to add toast components to the container.
 */
@Component({
  tag: 'sy-toast-container',
  styleUrls: ['scss/index.scss', 'scss/_tokens.scss'],
  shadow: true,
})
export class ToastContainer {
  @Element() el: HTMLSyToastContainerElement;

  /**
   * Defines the placement of the container inside its parent.
   */
  @Prop({ reflect: true }) placement:
    | 'left-top'
    | 'center-top'
    | 'right-top'
    | 'left-bottom'
    | 'center-bottom'
    | 'right-bottom';

  render() {
    return (
      <Host>
        <slot></slot>
      </Host>
    );
  }
}
